module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/funabashi_ekimae_point2-f7006fbd16fd818238b128b2e131cb00.jpg";